import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const ArrowBack = styled.img`
  height: 20px;
  width: auto;
`;

export const PageTitle = styled.span`
  font-family: BiotifSemiBold;
  font-size: 24px;
`;

export const NavTextLink = styled(NavLink)`
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const Container = styled.div`
  padding: 1rem 10rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  input {
    width: 20rem;
    padding: 10px;
    border: 1px solid #7f7f79;
    border-radius: 5px;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  gap: 15px;
  align-items: flex-end;
`;
export const RowFirst = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: flex-end;
  input {
    width: 17rem;
    padding: 10px;
    border: 1px solid #7f7f79;
    border-radius: 5px;
  }
`;
export const Rowlast = styled.div`
  display: flex;
  width: 100%;
  gap: 15px;
  align-items: flex-end;
`;

export const RowItem = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const Subtitle = styled.p`
  font: normal normal bold 16px Biotif;
`;
